/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currently_Logged_In_AsInputs */

const en_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently logged in as`)
};

const id_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ini login sebagai`)
};

const ms_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekarang ini log masuk sebagai`)
};

const ca_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualment has iniciat sessió com`)
};

const cs_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentálně jste přihlášeni jako`)
};

const da_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I øjeblikket er du logget ind som`)
};

const de_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentan angemeldet als`)
};

const et_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praegu sisse logitud kui`)
};

const es_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión iniciada como`)
};

const fr_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte actif :`)
};

const hr_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutačno ste prijavljeni kao`)
};

const it_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso effettuato come`)
};

const lv_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pašlaik pieteicies kā`)
};

const lt_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šiuo metu prisijungęs kaip`)
};

const hu_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezett felhasználó`)
};

const nl_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momenteel ingelogd als`)
};

const nb_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er logget inn som`)
};

const pl_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecnie zalogowano jako`)
};

const pt_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado atualmente como`)
};

const ro_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În prezent conectat ca`)
};

const sk_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentálne ste prihlásení ako`)
};

const sl_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutno ste prijavljeni kot`)
};

const fi_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tällä hetkellä kirjautuneena nimellä`)
};

const sv_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just nu inloggad som`)
};

const vi_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện đang đăng nhập với tư cách là`)
};

const tr_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut oturum sahibi: `)
};

const el_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έχετε συνδεθεί ως`)
};

const bg_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В момента си вписан/а в системата като`)
};

const ru_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы вошли в систему как`)
};

const sr_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренутно сте улоговани као`)
};

const uk_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наразі ви увійшли як`)
};

const ka_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ამჟამად შესულია, როგორც`)
};

const hi_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`करंट लोग इन `)
};

const th_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเข้าสู่ระบบในฐานะ`)
};

const ko_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 로그인 계정`)
};

const zh_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前登录为`)
};

const zh_tw_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前登入使用者為`)
};

const ja_currently_logged_in_as = /** @type {(inputs: Currently_Logged_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在ログイン中:`)
};

/**
* | output |
* | --- |
* | "Currently logged in as" |
*
* @param {Currently_Logged_In_AsInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const currently_logged_in_as = /** @type {((inputs?: Currently_Logged_In_AsInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currently_Logged_In_AsInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_currently_logged_in_as(inputs)
	if (locale === "ms") return ms_currently_logged_in_as(inputs)
	if (locale === "ca") return ca_currently_logged_in_as(inputs)
	if (locale === "cs") return cs_currently_logged_in_as(inputs)
	if (locale === "da") return da_currently_logged_in_as(inputs)
	if (locale === "de") return de_currently_logged_in_as(inputs)
	if (locale === "et") return et_currently_logged_in_as(inputs)
	if (locale === "es") return es_currently_logged_in_as(inputs)
	if (locale === "fr") return fr_currently_logged_in_as(inputs)
	if (locale === "hr") return hr_currently_logged_in_as(inputs)
	if (locale === "it") return it_currently_logged_in_as(inputs)
	if (locale === "lv") return lv_currently_logged_in_as(inputs)
	if (locale === "lt") return lt_currently_logged_in_as(inputs)
	if (locale === "hu") return hu_currently_logged_in_as(inputs)
	if (locale === "nl") return nl_currently_logged_in_as(inputs)
	if (locale === "nb") return nb_currently_logged_in_as(inputs)
	if (locale === "pl") return pl_currently_logged_in_as(inputs)
	if (locale === "pt") return pt_currently_logged_in_as(inputs)
	if (locale === "ro") return ro_currently_logged_in_as(inputs)
	if (locale === "sk") return sk_currently_logged_in_as(inputs)
	if (locale === "sl") return sl_currently_logged_in_as(inputs)
	if (locale === "fi") return fi_currently_logged_in_as(inputs)
	if (locale === "sv") return sv_currently_logged_in_as(inputs)
	if (locale === "vi") return vi_currently_logged_in_as(inputs)
	if (locale === "tr") return tr_currently_logged_in_as(inputs)
	if (locale === "el") return el_currently_logged_in_as(inputs)
	if (locale === "bg") return bg_currently_logged_in_as(inputs)
	if (locale === "ru") return ru_currently_logged_in_as(inputs)
	if (locale === "sr") return sr_currently_logged_in_as(inputs)
	if (locale === "uk") return uk_currently_logged_in_as(inputs)
	if (locale === "ka") return ka_currently_logged_in_as(inputs)
	if (locale === "hi") return hi_currently_logged_in_as(inputs)
	if (locale === "th") return th_currently_logged_in_as(inputs)
	if (locale === "ko") return ko_currently_logged_in_as(inputs)
	if (locale === "zh") return zh_currently_logged_in_as(inputs)
	if (locale === "zh-tw") return zh_tw_currently_logged_in_as(inputs)
	if (locale === "ja") return ja_currently_logged_in_as(inputs)
	return en_currently_logged_in_as(inputs)
});